import { HttpInterceptors } from "./http.interceptor";

export class RelationOperationService extends HttpInterceptors {
	async getTransactionsFromAllSources (filters) {
		const response = await this.axios.get("relationOperation/getTransactionsFromAllSources", { params: { filters } });
		return response.data;
	}

	async deleteOperation (payload) {
		const response = await this.axios.patch("relationOperation/deleteOperation", payload);
		return response.data;
	}
}
